// ─── Proppant / sand type reference ───────────────────────────────────────────
// Proppant descriptions and their true-density values.
//
// Consumers: TreatmentDataGraph (schedule editor), RulesManagementModal (Sand
// Slug Drop sand type picker), TreatmentModal (step description dropdown).
//
// Lives here rather than inside a component because TreatmentDataGraph already
// imports RulesManagementModal — exporting it from there and importing it back
// would be a circular import.

// Description dictionary for proppant types and their corresponding values
export const descriptionDictionary: { [key: string]: number } = {
  '30/70 White': 22.1,
  '30/80 FracBlack HT': 22.6,
  '35/140H Interprop': 26.688,
  '40/70 Black Pro': 22.3,
  '40/70 CarboLite': 22.601,
  '40/70 CarboProp': 27.272,
  '40/70 CRC': 20.767,
  '40/70 CRC - C': 21.017,
  '40/70 EconoProp': 22.518,
  '40/70 El-Prop': 22.6,
  '40/70 Interprop': 26.688,
  '40/70 MG Light': 22.601,
  '40/70 OilPlus': 21.7,
  '40/70 Pearl CRC': 22.6,
  '40/70 PowerProp': 20.683,
  '40/70 PRC': 20.767,
  '40/70 PRC Premium': 21.267,
  '40/70 Prime Plus': 21.7,
  '40/70 Super DC': 21.267,
  '40/70 Super LC': 21.35,
  '40/70 Tempered HS': 21.568,
  '40/70 TG': 22.1,
  '40/70 ValuBond': 21.767,
  '40/70 White': 22.1,
  '40/80 Bauxite (St. Gobain)': 29.19,
  '40/80 BauxLite': 26.688,
  '40/80 HydroProp': 21.267,
  '40/80 Interprop': 26.688,
  '40/80 SinterLite': 27.772,
  '20/40 GGL G2': 25.02,
  'GreenProp': 20.93,
  'SinterBall Lock': 27.939,
  'SinterBlast': 30.2,
  'SpearProp': 20.93,
  'Ultraprop': 29.19,
  'VersaLite': 25.02,
  'Versaprop': 26.688,
  '12/20 Brady': 22.1,
  '16/30 Brady': 22.1,
  '16/30 PC': 21.43,
  '20/40 Brady': 22.1,
  '20/40 CRC - E': 21.434,
  '20/40 PC': 21.43,
  '20/40 PPC': 21.43,
  '30/50 Brady': 22.1,
  '30/50 CRC - E': 21.434,
  '30/50 PC': 21.43,
  '30/50 PPC': 21.43,
  '30/70 Brady': 22.1,
  '40/70 Brady': 22.1,
  '40/70 Chieftain': 22.1,
  '40/70 CRC - E': 21.434,
  '40/70 PC': 21.43,
  '40/70 PPC': 21.43,
  '40/70 Optiprop-G2': 21.184,
  '16/30 OilPlus': 21.8,
  '20/40 Black Pro': 21.3,
  '30/50 Black Ultra': 21.3,
  '30/50 LW Manticore': 22.685,
  '30/50 Optiprop-G2': 21.184,
  '40/70 Garnet CRC': 22.6,
  '20/40 INNOPROP CR': 21.35,
  '20/40 INNOPROP PR': 21.35,
  '30/50 SSP': 22.1,
  'CarboNRT': 22.518,
  '100 SSP': 20.85,
  '40/70 SSP': 20.85,
  '16/30 CoolSet': 21.433,
  '20/40 CoolSet': 21.433,
  '30/50 CoolSet': 21.433,
  '40/70 CoolSet': 21.433,
  '30/50 P-1000': 22.018,
  '100 Mesh Native': 21.684,
  '40/70 Native': 21.767,
  '30/50 Native': 21.934,
  '20/40 Native': 21.767,
  '20/40 Trueset': 21.684,
  '30/50 Trueset': 21.684,
  '40/70 Trueset': 21.684,
  '30/70 Native': 21.767,
  '100 Mesh Arizona': 21.684,
  '20/40 Arizona': 21.767,
  '30/50 Arizona': 21.934,
  '40/70 Arizona': 21.767,
  '200 Mesh': 22.101,
  '40/70 TEMPERED LC': 21.434,
  '40/70 CRC-LT': 21.295,
  '30/50 CRC-LT': 21.267,
  '40/70 FloPro': 22.101,
  '40/70 Genoa': 21.851,
  '100 MESH FLO PRO': 20.85,
  '100 Mesh Brady': 22.101,
  '100 MESH TURBOPROP': 22.1,
  '100 Mesh Chrome': 21.35,
  '100 Super LC': 21.267,
  '40/70 Durasand': 21.934,
  '40/140 NATIVE': 21.35,
  'CS - 100 Mesh TG': 22.1,
  '100 Mesh TG': 22.1,
  '100 Mesh White': 22.1,
  '12/18 CarboHSP': 29.69,
  '12/18 CarboLite': 22.601,
  '12/18 El-Prop': 22.6,
  '12/18 Interprop': 26.688,
  '12/18 SinterLite': 27.021,
  '12/20 TG': 22.1,
  '12/20 White': 22.1,
  '14/20 SinterBall': 29.774,
  '14/40 FracBlack HT': 22.6,
  '14/40 XRT Ceramax V': 25.1,
  '16/20 CarboHSP': 29.69,
  '16/20 CarboLite': 22.601,
  '16/20 El-Prop': 22.6,
  '16/30 Bauxite (St. Gobain)': 29.19,
  '16/30 BauxLite Plus': 25.02,
  '16/30 CarboHSP': 29.69,
  '16/30 CarboProp': 27.272,
  '16/30 CRC': 20.767,
  '16/30 CRC - C': 21.017,
  '16/30 Garnet CRC': 22.6,
  '16/30 Hyperprop-G2': 25.02,
  '16/30 Interprop': 26.688,
  '16/30 Optiprop-G2': 21.184,
  '16/30 SiberProp': 21.267,
  '16/30 SinterBall': 29.774,
  '16/30 SinterLite': 27.021,
  '16/30 Super LC': 21.35,
  '16/30 TG': 22.1,
  '16/30 White': 22.1,
  '16/50 Interprop': 26.688,
  '20/40 Bauxite (St. Gobain)': 29.19,
  '20/40 BauxLite': 26.688,
  '20/40 BauxLite Plus': 25.02,
  '20/40 Black Ultra': 22.27,
  '20/40 CarboBond Lite': 21.684,
  '20/40 CarboHSP': 29.69,
  '20/40 CarboLite': 22.601,
  '20/40 CarboProp': 27.272,
  '20/40 CRC': 21.434,
  '20/40 CRC - C': 21.017,
  '20/40 CRC-LT': 21.434,
  '20/40 EconoProp': 22.518,
  '20/40 El-Prop': 22.6,
  '20/40 Garnet CRC': 22.6,
  '20/40 Hyperprop-G2': 25.02,
  '20/40 Interprop': 26.688,
  '20/40 MG Light': 22.601,
  '20/40 MG Light RCP': 22.601,
  '20/40 OilPlus': 21.7,
  '20/40 Optiprop-G2': 21.184,
  '20/40 Pearl CRC': 22.6,
  '20/40 PowerProp': 20.683,
  '20/40 PR6000': 21.571,
  '20/40 PRC': 21.434,
  '20/40 PRC Premium': 21.267,
  '20/40 SB Excel': 21.6,
  '20/40 SB Prime': 21.9,
  '20/40 SiberProp': 21.267,
  '20/40 SinterBall': 29.857,
  '20/40 SinterLite': 27.522,
  '20/40 SinterLite Lock': 27.939,
  '20/40 Super DC': 21.267,
  '20/40 Super LC': 20.933,
  '20/40 Tempered HS': 20.433,
  '20/40 Tempered LC': 20.433,
  '20/40 TG': 22.1,
  '20/40 ValuBond': 21.767,
  '20/40 White': 22.1,
  '20/40 XRT Ceramax E': 20.9,
  '20/40 XRT Ceramax P': 28.6,
  '30/50 Bauxite (St. Gobain)': 29.19,
  '30/50 BauxLite': 26.688,
  '30/50 CarboBond Lite': 21.684,
  '30/50 CarboLite': 22.601,
  '30/50 CRC - C': 21.017,
  '30/50 EconoProp': 22.518,
  '30/50 El-Prop': 22.6,
  '30/50 Garnet CRC': 22.6,
  '30/50 Interprop': 26.688,
  '30/50 MG Light': 22.601,
  '30/50 OilPlus': 21.7,
  '30/50 Pearl CRC': 22.6,
  '30/50 PowerProp': 20.683,
  '30/50 PRC': 20.767,
  '30/50 PRC Premium': 21.267,
  '30/50 Prime Plus': 21.7,
  '30/50 Super DC': 21.267,
  '30/50 Super LC': 21.35,
  '30/50 Tempered HS': 20.266,
  '30/50 Tempered LC': 20.433,
  '30/50 TG': 22.1,
  '30/50 White': 22.1,
  '30/50 XRT Ceramax V': 25.1,
  '30/60 CarboHSP': 29.69,
  '30/60 CarboProp': 27.272,
  '30/60 SinterBall': 29.941,
  '30/60 SinterLite': 27.772,
  '30/70 TG': 22.1,
  'CS - 100 Mesh White': 22.1,
  'CS - 12/18 CarboHSP': 29.69,
  'CS - 12/18 CarboLite': 22.601,
  'CS - 12/18 El-Prop': 22.6,
  'CS - 12/18 Interprop': 26.688,
  'CS - 12/18 SinterLite': 27.021,
  'CS - 12/20 TG': 22.1,
  'CS - 12/20 White': 22.1,
  'CS - 14/20 SinterBall': 29.774,
  'CS - 14/40 FracBlack HT': 22.6,
  'CS - 14/40 XRT Ceramax V': 25.1,
  'CS - 16/20 CarboHSP': 29.69,
  'CS - 16/20 CarboLite': 22.601,
  'CS - 16/20 El-Prop': 22.6,
  'CS - 16/30 Bauxite (St. Gobain)': 29.19,
  'CS - 16/30 BauxLite Plus': 25.02,
  'CS - 16/30 CarboHSP': 29.69,
  'CS - 16/30 CarboProp': 27.272,
  'CS - 16/30 CRC': 20.767,
  'CS - 16/30 CRC - C': 21.017,
  'CS - 16/30 Garnet CRC': 22.6,
  'CS - 16/30 Hyperprop-G2': 25.02,
  'CS - 16/30 Interprop': 26.688,
  'CS - 16/30 Optiprop-G2': 21.184,
  'CS - 16/30 SiberProp': 21.267,
  'CS - 16/30 SinterBall': 29.774,
  'CS - 16/30 SinterLite': 27.021,
  'CS - 16/30 Super LC': 21.35,
  'CS - 16/30 TG': 22.1,
  'CS - 16/30 White': 22.1,
  'CS - 16/50 Interprop': 26.688,
  'CS - 20/40 Bauxite (St. Gobain)': 29.19,
  'CS - 20/40 BauxLite': 26.688,
  'CS - 20/40 BauxLite Plus': 25.02,
  'CS - 20/40 Black Ultra': 22.27,
  'CS - 20/40 CarboBond Lite': 21.684,
  'CS - 20/40 CarboHSP': 29.69,
  'CS - 20/40 CarboLite': 22.601,
  'CS - 20/40 CarboProp': 27.272,
  'CS - 20/40 CRC': 21.434,
  'CS - 20/40 CRC - C': 21.017,
  'CS - 20/40 CRC-LT': 21.017,
  'CS - 20/40 EconoProp': 22.518,
  'CS - 20/40 El-Prop': 22.6,
  'CS - 20/40 Garnet CRC': 22.6,
  'CS - 20/40 Hyperprop-G2': 25.02,
  'CS - 20/40 Interprop': 26.688,
  'CS - 20/40 MG Light': 22.601,
  'CS - 20/40 MG Light RCP': 22.601,
  'CS - 20/40 OilPlus': 21.7,
  'CS - 20/40 Optiprop-G2': 21.184,
  'CS - 20/40 Pearl CRC': 22.6,
  'CS - 20/40 PowerProp': 20.683,
  'CS - 20/40 PR6000': 21.571,
  'CS - 20/40 PRC': 21.434,
  'CS - 20/40 PRC Premium': 21.267,
  'CS - 20/40 SB Excel': 21.6,
  'CS - 20/40 SB Prime': 21.9,
  'CS - 20/40 SiberProp': 21.267,
  'CS - 20/40 SinterBall': 29.857,
  'CS - 20/40 SinterLite': 27.522,
  'CS - 20/40 SinterLite Lock': 27.939,
  'CS - 20/40 Super DC': 21.267,
  'CS - 20/40 Super LC': 20.933,
  'CS - 20/40 Tempered HS': 20.433,
  'CS - 20/40 Tempered LC': 20.433,
  'CS - 20/40 TG': 22.1,
  'CS - 20/40 ValuBond': 21.767,
  'CS - 20/40 White': 22.1,
  'CS - 20/40 XRT Ceramax E': 20.9,
  'CS - 20/40 XRT Ceramax P': 28.6,
  'CS - 30/50 Bauxite (St. Gobain)': 29.19,
  'CS - 30/50 BauxLite': 26.688,
  'CS - 30/50 CarboBond Lite': 21.684,
  'CS - 30/50 CarboLite': 22.601,
  'CS - 30/50 CRC - C': 21.017,
  'CS - 30/50 EconoProp': 22.518,
  'CS - 30/50 El-Prop': 22.6,
  'CS - 30/50 Garnet CRC': 22.6,
  'CS - 30/50 Interprop': 26.688,
  'CS - 30/50 MG Light': 22.601,
  'CS - 30/50 OilPlus': 21.7,
  'CS - 30/50 Pearl CRC': 22.6,
  'CS - 30/50 PowerProp': 20.683,
  'CS - 30/50 PRC': 20.767,
  'CS - 30/50 PRC Premium': 21.267,
  'CS - 30/50 Prime Plus': 21.7,
  'CS - 30/50 Super DC': 21.267,
  'CS - 30/50 Super LC': 21.35,
  'CS - 30/50 Tempered HS': 20.266,
  'CS - 30/50 Tempered LC': 20.433,
  'CS - 30/50 TG': 22.1,
  'CS - 30/50 White': 22.1,
  'CS - 30/50 XRT Ceramax V': 25.1,
  'CS - 30/60 CarboHSP': 29.69,
  'CS - 30/60 CarboProp': 27.272,
  'CS - 30/60 SinterBall': 29.941,
  'CS - 30/60 SinterLite': 27.772,
  'CS - 30/70 TG': 22.1,
  'CS - 30/70 White': 22.1,
  'CS - 30/80 FracBlack HT': 22.6,
  'CS - 35/140H Interprop': 26.688,
  'CS - 40/70 Black Pro': 22.3,
  'CS - 40/70 CarboLite': 22.601,
  'CS - 40/70 CarboProp': 27.272,
  'CS - 40/70 CRC': 20.767,
  'CS - 40/70 CRC - C': 21.017,
  'CS - 40/70 EconoProp': 22.518,
  'CS - 40/70 El-Prop': 22.6,
  'CS - 40/70 Interprop': 26.688,
  'CS - 40/70 MG Light': 22.601,
  'CS - 40/70 OilPlus': 21.7,
  'CS - 40/70 Pearl CRC': 22.6,
  'CS - 40/70 PowerProp': 20.683,
  'CS - 40/70 PRC': 20.767,
  'CS - 40/70 PRC Premium': 21.267,
  'CS - 40/70 Prime Plus': 21.7,
  'CS - 40/70 Super DC': 21.267,
  'CS - 40/70 Super LC': 21.35,
  'CS - 40/70 Tempered HS': 21.568,
  'CS - 40/70 TG': 22.1,
  'CS - 40/70 ValuBond': 21.767,
  'CS - 40/70 White': 22.1,
  'CS - 40/80 Bauxite (St. Gobain)': 29.19,
  'CS - 40/80 BauxLite': 26.688,
  'CS - 40/80 HydroProp': 21.267,
  'CS - 40/80 Interprop': 26.688,
  'CS - 40/80 SinterLite': 27.772,
  'CS - 20/40 GGL G2': 25.02,
  'CS - GreenProp': 20.93,
  'CS - SinterBall Lock': 27.939,
  'CS - SinterBlast': 30.2,
  'CS - SpearProp': 20.93,
  'CS - Ultraprop': 29.19,
  'CS - VersaLite': 25.02,
  'CS - Versaprop': 26.688,
  'CS - 12/20 Brady': 22.1,
  'CS - 16/30 Brady': 22.1,
  'CS - 16/30 PC': 21.43,
  'CS - 20/40 Brady': 22.1,
  'CS - 20/40 CRC - E': 21.434,
  'CS - 20/40 PC': 21.43,
  'CS - 20/40 PPC': 21.43,
  'CS - 30/50 Brady': 22.1,
  'CS - 30/50 CRC - E': 21.434,
  'CS - 30/50 PC': 21.43,
  'CS - 30/50 PPC': 21.43,
  'CS - 30/70 Brady': 22.1,
  'CS - 40/70 Brady': 22.1,
  'CS - 40/70 Chieftain': 22.1,
  'CS - 40/70 CRC - E': 21.434,
  'CS - 40/70 PC': 21.43,
  'CS - 40/70 PPC': 21.43,
  'CS - 40/70 Optiprop-G2': 21.184,
  'CS - 16/30 OilPlus': 21.8,
  'CS - 20/40 Black Pro': 21.3,
  'CS - 30/50 Black Ultra': 21.3,
  'CS - 30/50 LW Manticore': 22.685,
  'CS - 30/50 Optiprop-G2': 21.184,
  'CS - 30/50 TerraProp': 26.771,
  'CS - 30/50 ProLite': 22.935,
  'CS - 40/70 ProLite': 22.101,
  'CS - 100 Super LC': 21.267,
  'CS - 100 Mesh Native': 22.1,
  'CS - 40/70 Native': 22.1,
  'CS - 200 Mesh': 22.101
};

// Sorted description options for dropdowns.
export const getDescriptionOptions = (): string[] =>
  Object.keys(descriptionDictionary).sort();

// True density for a description. 22.101 is the historical fallback for a
// description that is not in the table.
export const getDescriptionValue = (description: string): number =>
  descriptionDictionary[description] || 22.101;
